<template>
  <div class="edit-task-container basicStyle">
    <div class="querySearch">
      <el-form :inline="true" :model="taskFormData" class="demo-form-inline">
        <el-form-item label="任务名称:" style="margin-right: 20px;">
          <span class="taskName">{{ taskFormData.taskInfo.name }}</span>
          <i class="el-icon-edit" @click="changeTaskName" style="margin-left: 10px;cursor: pointer;font-size: 20px;"></i>
        </el-form-item>
        <el-form-item label="信息查询" class="info-search-input">
          <el-input
            placeholder="支持姓名、手机号码模糊查询"
            v-model="taskFormData.infoSearch"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="跟进状态：" class="follow-status">
          <el-select
            v-model="taskFormData.status"
            size="small"
            class="w200Select"
            @change="statusChange"
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item> 
          <el-button type="primary" @click="getEditTaskData">搜索</el-button>
          <el-button type="warning" @click="resetInfoSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 修改任务名字弹窗 -->
    <el-dialog
      @close="cancelChange"
      title="修改任务名字"
      :visible.sync="changeTaskData.visible"
      class="formDialog"
      width="500px"
    >
      <div class="name-box">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="changeTaskData.text"
          maxlength="15"
          show-word-limit
          clearable
        >
        </el-input>
      </div>
      <div class="btn-box">
        <el-button type="primary" class="btn" @click="cancelChange"
          >取消</el-button
        >
        <el-button type="primary" class="btn" @click="submitChangeTaskName"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <!-- 追加数据 -->
    <div class="add-data-box">
      <el-row :gutter="20">
        <el-col :span="6"
          ><div class="grid-content bg-purple" @click="singleAddData">
            单个追加数据
          </div></el-col
        >
        <el-col :span="6"
          ><div class="grid-content bg-purple" @click="batchleAddData">
            批量追加数据
          </div></el-col
        >
        <el-col v-if="taskFormData.status==2" :span="6">
          <MyButton
            value="批量删除未接通号码"
            size="medium"
            type="4"
            @click="batchUser(1)"
          ></MyButton>
        </el-col>
        <el-col v-if="taskFormData.status===0" :span="6">
          <MyButton
            value="批量删除未联系号码"
            size="medium"
            type="4"
            @click="batchUser(2)"
          ></MyButton>
        </el-col> 
        

        <!-- <el-col :span="6"
          ><div class="grid-content bg-purple" @click="openBatchleDelete">
            批量删除
          </div></el-col
        > -->
      </el-row>
    </div>
    <!-- taskData 任务数据 -->
    <el-table
      :data="taskData"
      style="width: 100%"
      border
      @selection-change="selectChange"
      ref="multipleTaskTable"
    >
      <!-- <el-table-column type="selection" width="55"></el-table-column> -->
      <el-table-column
        prop="fullname"
        label="姓名"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="score"
        label="分数"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="exam"
        label="考试名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="province"
        label="省份"
        align="center"
      ></el-table-column>
      <el-table-column prop="city" label="市" align="center"></el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="import_at"
        label="导入时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="status_name"
        label="状态"
        align="center"
      ></el-table-column>
      <el-table-column prop="operate" label="操作" align="center">
        <template slot-scope="scope">
          <!-- 在组件内部需要通过插槽的scope来获取传递的数据 scope.row.-->
          <div class="operate-box">
            <div class="edit" @click="editSingleTask(scope.row)">编辑</div>
            <div class="delete" @click="deleteSingleTaskPop(scope.row)">
              删除
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="foot-page"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="taskParams.page"
      :page-sizes="[10, 15, 20, 30]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="taskParams.total"
    >
    </el-pagination>
    <!-- <div class="select-page-box">
      <el-checkbox v-model="deleteBatchleData.isCurrentPage" @change="changeCurrentPageStatus">当前页</el-checkbox>
      <el-checkbox v-model="deleteBatchleData.isAllPage" @change="changeAllPageStatus">所有页</el-checkbox>
    </div> -->
    <!-- 追加数据弹窗 -->
    <el-dialog
      @close="cancelAdd('ruleForm')"
      title="客户信息"
      :visible.sync="addPopUpVisible"
      class="formDialog"
      width="500px"
    >
      <div class="pop-up">
        <el-form
          :rules="rules"
          ref="ruleForm"
          label-position="right"
          label-width="80px"
          :model="clientFormInfo"
        >
          <el-form-item label="名称" prop="fullname">
            <el-input
              v-model="clientFormInfo.fullname"
              maxlength="15"
              show-word-limit
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input
              v-model.number="clientFormInfo.mobile"
              maxlength="11"
              show-word-limit
              clearable
              :disabled="clientFormInfo.id >= 0"
            ></el-input>
          </el-form-item>
          <el-form-item label="考试名称" prop="exam">
            <el-input
              v-model="clientFormInfo.exam"
              maxlength="15"
              show-word-limit
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="分数" prop="score">
            <el-input
              v-model.number="clientFormInfo.score"
              maxlength="8"
              show-word-limit
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="省份" prop="province_id">
            <el-select
              v-model="clientFormInfo.province_id"
              placeholder="请选择"
              filterable
              clearable
            >
              <el-option
                v-for="item in provinceOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="市" prop="city_id">
            <el-select
              v-model="clientFormInfo.city_id"
              :disabled="cityDisabled"
              placeholder="请选择"
              filterable
              clearable
            >
              <el-option
                v-for="item in cityOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn-box">
        <el-button type="primary" class="btn" @click="cancelAdd('ruleForm')"
          >取消</el-button
        >
        <el-button type="primary" class="btn" @click="saveAdd('ruleForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <!-- 删除单条数据弹窗 -->
    <el-dialog
      title=""
      :visible.sync="deleteTaskData.visible"
      class="formDialog"
      width="500px"
    >
      <div class="name-box" style="text-align: center;">是否删除此数据！</div>
      <div class="btn-box">
        <el-button
          type="primary"
          size="mini"
          class="btn"
          @click="deleteTaskData.visible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          size="mini"
          class="btn"
          @click="deleteSingleTask"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <!-- 批量删除数据的弹窗 -->
    <el-dialog
      :visible.sync="deleteBatchleData.visible"
      class="formDialog delete-pop-box"
      width="400px"
      @close="closeDeleteBatchle"
    >
      <div class="delete-title" slot="title">批量删除</div>
      <div class="content-box">
        <div>确定删除以下数据？</div>
        <div>
          总计：客户数据共
          <span>{{ deleteBatchleData.deleteDataArr.length }}</span> 条
        </div>
      </div>
      <div class="delete-footer" slot="footer">
        <el-button @click="closeDeleteBatchle">取消</el-button>
        <el-button @click="batchleDeleteData">确定</el-button>
      </div>
    </el-dialog>
    <!-- 导入数据组件 -->
    <ImportOwnNumberAdd
      ref="ImportOwnNumberRef"
      :task_name="taskFormData.taskInfo.name"
      :task_id="taskFormData.taskInfo.id"
      @outerRefresh="outerRefresh"
    ></ImportOwnNumberAdd>


    <el-dialog
      title=""
      :visible.sync="batchUserVisible"
      class="formDialog"
      width="500px"
    >
      <div class="name-box">
        <div v-if="batchUserType==1">
          确认要删除
          <span style="color:red">{{ batchUserCount }}</span>
          未接通号码？</div>
        <div v-else>
          确认要删除
          <span style="color:red">{{ batchUserCount }}</span>
          未联系号码？</div>
      </div>
      <div class="btn-box">
        <el-button
          type="primary"
          size="mini"
          class="btn"
          @click="batchUserVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          size="mini"
          class="btn"
          @click="batchUserSave"
          >确认</el-button
        >
      </div>
    </el-dialog>

  </div>
</template>

<script>
import callPhoneApi from "@/api/callphone";
import commonApi from "@/api/common";
import ImportOwnNumberAdd from "@/components/ImportOwnNumberAdd.vue";
import MyButton from "@/components/MyButton.vue";

export default {
  name: "editTask", // 编辑任务
  components: {
    // 导入数据组件
    ImportOwnNumberAdd,
    MyButton
  },
  data() {
    // 检测手机号验证规则
    var checkMobile = (rule, value, callback) => {
      value = value + "";
      if (value.length !== 11) {
        return callback(new Error("请输入11位数的号码"));
      } else {
        return callback();
      }
    };
    var checkScore = (rule, value, callback) => {
      if(value) {
        if(typeof value !== "number") {
          return callback(new Error("分数必须为数字值"));
        } else {
          return callback();
        }
      } else {
        return callback();
      }
    };
    return {
      // 任务表单数据
      taskFormData: {
        taskInfo: {
          id: "",
        },
        infoSearch: "",
      },
      // 任务名称列表
      taskNameData: [],
      // 改变任务弹窗信息
      changeTaskData: {
        visible: false, //是否可见
        text: "", // 任务名称
      },
      // 删除单条数据信息
      deleteTaskData: {
        visible: false,
        finish: true,
        data_id: "", // 具体单条数据的id
      },
      // 批量删除的任务数据
      deleteBatchleData: {
        visible: false,
        deleteDataArr: [], // 删除的任务数组
        isCurrentPage: false, // 全选时是否是当前页
        isAllPage: false, // 全选是否为全部页面数据
      },
      // 任务数据
      taskData: [],
      // 任务页面请求参数
      taskParams: {
        page: 1,
        limit: 10,
        total: 0,
      },
      //  客户表单信息
      clientFormInfo: {
        fullname: "", // 姓名
        mobile: "", // 手机
        exam: "", // 考试名称
        score: "", // 分数
        province_id: "", // 省份id
        city_id: "", // 城市id
      },
      // 追加数据弹窗是否显示
      addPopUpVisible: false,
      // 省份信息
      provinceOptions: [],
      // 市区信息
      cityOptions: [],
      // 表单验证规则
      rules: {
        mobile: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          { validator: checkMobile, trigger: "blur" },
          { type: "number", message: "手机号须为数字值", trigger: "blur" },
        ],
        score: [
          { required: false, validator: checkScore, trigger: "blur" },
          // { type: "number", message: "分数须为数字值", trigger: "blur" },
        ],
      },
      statusOptions:[],
      batchUserType: '',
      batchUserVisible: false, 
      batchUserCount:0
    };
  },
  created() {
    // 获取上一个页面传过来的参数
    this.taskFormData.taskInfo.id = this.$route.query.id;
    // 获取省份信息
    this.getProvinces();
    // 获取编辑任务数据列表
    this.getEditTaskData();
  },
  activated() {
    this.taskFormData.taskInfo.id = this.$route.query.id;
    this.getEditTaskData();
  },
  watch: {
    // 监听省份id，只有省份有值时才开始获取市区
    "clientFormInfo.province_id"(newVal, oldVal) {
      // 获取市区信息
      this.getCitys();
    },
  },
  computed: {
    // 是否显示可选城市
    cityDisabled() {
      if (this.clientFormInfo.province_id) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    statusChange(){
      console.log("statusChange", this.taskFormData.status)
      this.getEditTaskData();
    },
    batchUserSave(){
      callPhoneApi.batchUser({
        batch_type:this.batchUserType,
        task_id:this.taskFormData.taskInfo.id,
      }).then((res) => {
        if (res.code === 200) {
          const successMessage =  '已成功删除' + res.data.success + '个号码'
          this.$message({ 
            type: "success",
            message: successMessage,
          });
          this.batchUserVisible = false

          this.taskFormData.status = ""
          this.getEditTaskData()
        }
      })
    },
    batchUser(e){
      this.batchUserType = e
      console.log("batchUser", e)  
      callPhoneApi.getUserCount({
        batch_type:this.batchUserType,
        task_id:this.taskFormData.taskInfo.id,
      }).then((res) => {
        if (res.code === 200) {
          if(res.data.count>0) {
            this.batchUserCount = res.data.count
            this.batchUserVisible = true 
          }else{
            this.$message({ 
              type: "warning",
              message: "暂未找到可操作外呼用户！",
            });
          }
        }
      })
    },


    // 修改任务名称
    changeTaskName() {
      this.changeTaskData.visible = true;
    },
    // 取消修改任务名字
    cancelChange() {
      this.changeTaskData.visible = false;
      this.changeTaskData.text = "";
    },
    // 提交修改任务名称
    submitChangeTaskName() {
      const data = {
        task_id: this.taskFormData.taskInfo.id,
        task_name: this.changeTaskData.text,
      };
      callPhoneApi.submitChangeTaskName(data).then((res) => {
        if (res.code === 200) {
          this.changeTaskData.visible = false;
          this.changeTaskData.text = "";
          this.getEditTaskData();
        } else if (res.code === 400) {
          this.$message(res.message);
        }
      });
    },
    // 追加单个数据
    singleAddData() {
      this.addPopUpVisible = true;
    },
    // 批量添加数据
    batchleAddData() {
      console.log("批量添加数据");
      this.$refs.ImportOwnNumberRef.show();
      this.$refs.ImportOwnNumberRef.getTobAllAcCount();
    },
    // 改变每一页尺寸触发的函数
    handleSizeChange(val) {
      this.taskParams.limit = val;
      this.taskParams.page = 1;
      this.getEditTaskData();
    },
    // 改变页面触发的函数
    handleCurrentChange(val) {
      this.taskParams.page = val;
      this.getEditTaskData();
    },
    // 获取编辑数据任务列表
    getEditTaskData() {
      const params = {
        limit: this.taskParams.limit,
        page: this.taskParams.page,
        task_id: this.taskFormData.taskInfo.id,
        keyword: this.taskFormData.infoSearch,
        status: this.taskFormData.status,
      };
      callPhoneApi.getEditTaskData(params).then((res) => {
        if (res.code === 200) {
          console.log("res", res.data);
          // if (res.data.total === 0) {
          //   this.$router.push("/taskList");
          // }
          // 所有页面是勾选状态，请求页面之后直接全选页面数据
          if (this.deleteBatchleData.isAllPage) {
            this.$refs.multipleTaskTable.toggleAllSelection();
          }
          // 只要请求了数据，就取消当前页面的勾选状态
          this.deleteBatchleData.isCurrentPage = false;
          this.taskData = res.data.data;
          this.taskFormData.taskInfo = res.data.task_info;
          this.taskParams.total = res.data.total;

          this.statusOptions = res.data.status_list;
        }
      });
    },
    // 编辑单个任务数据
    editSingleTask(data) {
      this.clientFormInfo = data;
      this.clientFormInfo.mobile = +data.mobile;
      // this.clientFormInfo.score = +data.score;

      this.clientFormInfo.score = data.score ? data.score : "";
      this.clientFormInfo.province_id = data.province_id
        ? data.province_id
        : "";
      this.clientFormInfo.city_id = data.city_id ? data.city_id : "";
      this.addPopUpVisible = true;
    },
    // 删除单个任务数据弹窗
    deleteSingleTaskPop(data) {
      this.deleteTaskData.data_id = data.id;
      this.deleteTaskData.visible = true;
    },
    // 删除单个任务数据
    deleteSingleTask() {
      const deleteData = {
        task_id: this.taskFormData.taskInfo.id,
        data_id: this.deleteTaskData.data_id,
      };
      callPhoneApi.deleteSingleTask(deleteData).then((res) => {
        if (res.code === 200) {
          this.getEditTaskData();
          this.deleteTaskData.visible = false;
        } else if (res.code === 400) {
          this.$message(res.message);
          this.deleteTaskData.visible = false;
        }
      });
    },
    // 获取省份信息
    getProvinces() {
      commonApi.getProvinces().then((res) => {
        if (res.code) {
          this.provinceOptions = res.data;
        }
      });
    },
    // 获取市区信息
    getCitys() {
      commonApi
        .getCitys({ id: this.clientFormInfo.province_id })
        .then((res) => {
          if (res.code) {
            this.cityOptions = res.data;
          }
        });
    },
    // 取消追加任务
    cancelAdd(ruleForm) {
      this.addPopUpVisible = false;
      this.clientFormInfo = {
        // fullname: "", // 姓名
        // mobile: "", // 手机
        // exam: "", // 考试名称
        // score: "", // 分数
        // province_id: "", // 省份id
        // city_id: "", // 城市id
        // is_jietong: "", // 是否接通
      };
      // 清空校验规则
      this.$refs[ruleForm].resetFields();
    },
    // 保存追加任务
    saveAdd(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if(!this.clientFormInfo.score) {
          this.clientFormInfo.score = ''
        }
        if (valid) {
          // 有id，说明是 编辑 进入这里的。否则是单个导入
          if (this.clientFormInfo.id) {
            // 当客户号码为已接通时，给后端的手机号直接传空
            if (this.clientFormInfo.is_jietong === 1) {
              this.clientFormInfo.mobile = "";
            }
            const editData = {
              task_id: this.taskFormData.taskInfo.id,
              ...this.clientFormInfo,
            };
            callPhoneApi.taskUserDo(editData).then((res) => {
              console.log("res", res);
              if (res.code === 200) {
                console.log("res", res);
                // 验证成功任务提交
                this.$message({
                  dangerouslyUseHTMLString: true,
                  type: "success",
                  message: `任务编辑成功`,
                });
                this.getEditTaskData();
                // 取消追加任务函数，重置客户表单信息 clientFormInfo
                this.cancelAdd();
                this.addPopUpVisible = false;
              } else {
                this.$message(res.message);
              }
            });
          } else {
            const editData = {
              task_id: this.taskFormData.taskInfo.id,
              ...this.clientFormInfo,
            };
            callPhoneApi.taskUserDo(editData).then((res) => {
              if (res.code === 200) {
                // 验证成功任务提交
                this.$message({
                  dangerouslyUseHTMLString: true,
                  type: "success",
                  message: `新增成功，请前往<span style="color: #f40">任务管理</span>列表页面-为新增数据分配呼叫员工`,
                });
                this.getEditTaskData();
                // 取消追加任务函数，重置客户表单信息 clientFormInfo
                this.cancelAdd();
                this.addPopUpVisible = false;
              } else {
                this.$message(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 重置搜索内容
    resetInfoSearch() {
      this.taskFormData.infoSearch = "";
      this.taskFormData.status = ""; 
      this.taskParams.page = 1;
      this.$forceUpdate()
      this.getEditTaskData();
    },
    // 导入数据组件
    outerRefresh(e) {
      console.log("导入数据关闭", e);
      this.getEditTaskData();
    },
    // 批量删除数据
    batchleDeleteData() {
      console.log("批量删除");
    },
    // 打开批量删除弹窗
    openBatchleDelete() {
      if (this.deleteBatchleData.deleteDataArr.length === 0) {
        this.$message("请选择需要删除的数据！");
      } else {
        this.deleteBatchleData.visible = true;
      }
    },
    // 关闭批量删除数据弹窗
    closeDeleteBatchle() {
      console.log("关闭");
    },
    // 用户选择的数据
    selectChange(val) {
      console.log("val", val);
      this.deleteBatchleData.deleteDataArr = val;
    },
    // 改变当前页标签状态
    changeCurrentPageStatus() {
      if (this.deleteBatchleData.isCurrentPage) {
        // 所有页 不被选中
        this.deleteBatchleData.isAllPage = false;
        if (
          this.deleteBatchleData.deleteDataArr.length === this.taskParams.limit
        ) {
          return;
        } else if (this.deleteBatchleData.deleteDataArr.length >= 0) {
          this.$refs.multipleTaskTable.clearSelection();
          this.$refs.multipleTaskTable.toggleAllSelection();
        }
      } else {
        // 清空选择
        this.$refs.multipleTaskTable.clearSelection();
      }
    },
    // 改变所有页标签状态
    changeAllPageStatus() {
      if (this.deleteBatchleData.isAllPage) {
        // 当前页 不被选中
        this.deleteBatchleData.isCurrentPage = false;
        this.$refs.multipleTaskTable.clearSelection();
        this.$refs.multipleTaskTable.toggleAllSelection();
      } else {
        // 清空选择
        this.$refs.multipleTaskTable.clearSelection();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.edit-task-container {
  position: relative;
  .head-box {
    width: 60%;
    display: flex;
    justify-content: space-between;
    .info-search-input {
      margin-left: 100px;
    }
  }
  .formDialog {
    .btn-box {
      margin-top: 20px !important;
      .btn {
        margin: 0 20px;
      }
    }
  }

  .change-task-name-btn {
    font-size: 8px;
  }
  .add-data-box {
    width: 600px;
    margin-top: 30px;
    font-size: 14px;
    text-align: center;
    height: 36px;
    color: #ffffff;
    margin-bottom: 20px;
    div {
      height: 100%;
      line-height: 36px;
      cursor: pointer;
    }
  }
  .foot-page {
    margin-top: 20px;
  }
  .select-page-box {
    margin-top: 10px;
  }
  .operate-box {
    display: flex;
    justify-content: center;
    .edit {
      margin: 8px;
      cursor: pointer;
      color: #409eff;
    }
    .delete {
      margin: 8px;
      cursor: pointer;
      color: red;
    }
  }

  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #606266;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
  .btn-box {
    display: flex;
    justify-content: center;
    width: 100%;
    .btn {
      margin: 0 40px;
    }
  }
  .delete-pop-box {
    .delete-title {
      width: 100%;
      font-weight: bold;
      text-align: center;
    }
    .delete-footer {
      display: flex;
      width: 100%;
      justify-content: space-around;
    }
    .content-box {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      div {
        text-align: center;
        margin: 10px;
        span {
          color: #f40;
        }
      }
    }
  }
}
/deep/.el-input .el-input__count-inner{
  background-color: #F7F8FB!important;
}
</style>
